import updateFieldOfStudy from './getUserPreferences/v7/updateFieldOfStudy';

export default (params) => {
  const { fieldType } = params;

  if (fieldType === 'userPreferences') {
    return updateFieldOfStudy(params);
  }

  return null;
};
